/**
 * ブランド書体（CADEC ワードマーク等）
 * 確定: ③ COLLEN（Michroma）
 */

/** 採用パターン: p3-collen（index 2） */
export const DEFAULT_BRAND_PATTERN_INDEX = 2;

export const BRAND_PATTERNS = [
  {
    id: "p1-nolan",
    index: 0,
    /** 比較UI用 */
    code: "①",
    name: "NOLAN",
    hint: "極太コンデンス / オールキャップ",
    fontFamily: '"Bebas Neue", sans-serif' as const,
    wordmarkWeight: 400,
    wordmarkLetterSpacing: "0.04em",
    wordmarkChars: ["C", "A", "D", "E", "C"] as const,
    englishHeadWeight: 400,
    englishBodyWeight: 300,
    englishCasing: "allcaps" as const,
  },
  {
    id: "p2-caelan",
    index: 1,
    code: "②",
    name: "Caelan",
    hint: "クリーン / 語頭のみ大文字",
    fontFamily: '"Montserrat", sans-serif' as const,
    wordmarkWeight: 500,
    wordmarkLetterSpacing: "0.02em",
    wordmarkChars: ["C", "a", "d", "e", "c"] as const,
    englishHeadWeight: 500,
    englishBodyWeight: 400,
    englishCasing: "title" as const,
  },
  {
    id: "p3-collen",
    index: 2,
    code: "③",
    name: "COLLEN",
    hint: "ワイド / 近未来",
    fontFamily: '"Michroma", sans-serif' as const,
    wordmarkWeight: 400,
    wordmarkLetterSpacing: "0.12em",
    wordmarkChars: ["C", "A", "D", "E", "C"] as const,
    englishHeadWeight: 400,
    englishBodyWeight: 300,
    englishCasing: "allcaps" as const,
  },
  {
    id: "p4-gihan",
    index: 3,
    code: "④",
    name: "GIHAN",
    hint: "極窄・高さ / 建築的",
    fontFamily: '"Teko", sans-serif' as const,
    wordmarkWeight: 500,
    wordmarkLetterSpacing: "0.04em",
    wordmarkChars: ["C", "A", "D", "E", "C"] as const,
    englishHeadWeight: 500,
    englishBodyWeight: 400,
    englishCasing: "allcaps" as const,
  },
] as const;

export type BrandPattern = (typeof BRAND_PATTERNS)[number];

/** Michroma：見た目が横幅大きめ。CSS 側の `--michroma` 修飾と併用 */
export function isMichromaBrand(p: { id: string }): boolean {
  return p.id === "p3-collen";
}

export function readSavedBrandPatternIndex(): number {
  return DEFAULT_BRAND_PATTERN_INDEX;
}

export function persistBrandPatternIndex(_i: number): void {
  /* 書体確定のため切替保存は行わない */
}

/** 英名行: 各トークンをパターンのケース方針で分割 */
export function formatEnglishToken(
  word: string,
  casing: BrandPattern["englishCasing"],
): { head: string; rest: string } {
  if (word.length === 0) return { head: "", rest: "" };
  const h = word[0] ?? "";
  const r = word.slice(1);
  if (casing === "title") {
    return { head: h.toLocaleUpperCase("en"), rest: r.toLocaleLowerCase("en") };
  }
  return { head: h.toLocaleUpperCase("en"), rest: r.toLocaleUpperCase("en") };
}
